<template>
  <!-- Confirmación. HTML + CSS plano (sin v-dialog / v-card / v-tooltip) para que funcione igual en Windows 7. -->
  <div v-if="globalStore.confirmDialog" class="ps-modal" role="alertdialog" aria-modal="true">
    <div class="ps-modal__card ps-confirm">
      <h2 class="ps-confirm__title">{{ globalStore.confirm.title.toUpperCase() }}</h2>

      <div class="ps-confirm__body">{{ globalStore.confirm.body }}</div>

      <div class="ps-modal__actions ps-modal__actions--split ps-confirm__actions">
        <button type="button" class="ps-btn ps-btn--ghost ps-btn--danger-outline" @click="globalStore.closeConfirm">
          <i class="mdi mdi-close" aria-hidden="true"></i>
          {{ resources.Cancel }}
        </button>

        <button type="button" class="ps-btn ps-btn--primary" @click="globalStore.confirm.callback">
          <i class="mdi mdi-content-save-outline" aria-hidden="true"></i>
          {{ resources.Confirm }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";

const globalStore = window.useGlobalStore();

const { resources } = storeToRefs(globalStore);
</script>

<style scoped>
.ps-confirm {
  max-width: 500px;
  padding: 0;
}

.ps-confirm__title {
  margin: 0;
  padding: 16px 24px;
  background: #124b4e;
  color: #ffffff;
  font-family: var(--ps-font-title, "Poppins", Arial, sans-serif);
  font-size: 17px;
  font-weight: 700;
}

.ps-confirm__body {
  padding: 22px 24px 6px;
  font-size: 15px;
  line-height: 1.5;
}

.ps-confirm__actions {
  padding: 0 24px 22px;
}

.ps-btn--danger-outline {
  border-color: #d44c4c;
  color: #c0392b;
}

.ps-btn--danger-outline:hover {
  background: rgba(212, 76, 76, 0.12);
}
</style>
